import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChatKnowledgeService {
  private readonly _knowledgeBaseMessage$ = new Subject<any>();
  readonly knowledgeBaseMessage$ = this._knowledgeBaseMessage$.asObservable();

  setKnowledgeBaseMessage(responseId: string, message: string, attachments: File[]) {
    this._knowledgeBaseMessage$.next({ responseId, message, attachments });
  }
}
